const ALLOWED_EXTERNAL_SCHEMES = new Set(['http:', 'https:', 'mailto:', 'tel:']);

// Regex to match control characters (0-31 and 127)
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS_RE = /[\x00-\x1f\x7f]/;
// Regex to extract the scheme (e.g. "https:")
const SCHEME_RE = /^([a-z][a-z0-9+.-]*:)/i;

export function normalizeHref(href: string | undefined): string | undefined {
    return href?.trim() || undefined;
}

function isInvalid(href: string): boolean {
    return CONTROL_CHARS_RE.test(href);
}

export function isExternalHref(href: string | undefined): boolean {
    if (!href || isInvalid(href)) return false;

    if (href.startsWith('//')) return true;

    const scheme = href.match(SCHEME_RE)?.[0].toLowerCase();
    return !!scheme && ALLOWED_EXTERNAL_SCHEMES.has(scheme);
}

export function isInternalHref(href: string | undefined): boolean {
    if (!href || isInvalid(href)) return false;

    return href.startsWith('/') && !href.startsWith('//');
}

export function isAllowedHref(href: string | undefined): boolean {
    if (!href) return false;
    return isInternalHref(href) || isExternalHref(href);
}
